import React, { useState, useEffect } from "react";
import useFetch from "../../../../hooks/useFetch";

// Surfaced in ReunionEventControl's "start" tab, before the admin goes live —
// picking Level 5 questions after the event is already running would mean
// participants mid-Level-5 see a pool that shifts under them.

const ReunionLevel5Picker = ({ event }) => {
  const { fetchData } = useFetch();
  const [pool, setPool] = useState([]);
  const [selected, setSelected] = useState(event.level5QuestionIds || []);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetchData({
        url: "/reunion/game/level5-pool",
        method: "GET",
      });
      if (response?.status) setPool(response.data);
    })();
    // eslint-disable-next-line
  }, []);

  const toggle = (id) => {
    setSaved(false);
    setSelected((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= 3) return prev; // hard cap at 3, per spec
      return [...prev, id];
    });
  };

  const handleSave = async () => {
    setSaving(true);
    const response = await fetchData({
      url: `/reunion/game/level5-questions/${event._id}`,
      method: "PUT",
      data: { questionIds: selected },
    });
    setSaving(false);
    if (response?.status) setSaved(true);
  };

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-bold text-cyan-200">
          🎯 Level 5 Questions — pick exactly 3
        </h3>
        <span className="text-sm text-emerald-300">{selected.length}/3 selected</span>
      </div>

      <div className="space-y-2 max-h-80 overflow-y-auto pr-2">
        {pool.map((q) => (
          <label
            key={q._id}
            className={`flex items-start gap-3 rounded-xl p-3 border cursor-pointer transition-all ${
              selected.includes(q._id)
                ? "bg-emerald-500/20 border-emerald-400"
                : "bg-white/5 border-white/10 hover:bg-white/10"
            }`}
          >
            <input
              type="checkbox"
              checked={selected.includes(q._id)}
              onChange={() => toggle(q._id)}
              className="mt-1"
            />
            <div>
              <div className="text-xs text-emerald-300 uppercase tracking-wide">
                {q.category}
              </div>
              <div className="text-sm">{q.payload?.text}</div>
            </div>
          </label>
        ))}
      </div>

      <button
        onClick={handleSave}
        disabled={selected.length !== 3 || saving}
        className="w-full mt-4 rounded-xl py-3 bg-gradient-to-r from-violet-500 to-purple-600 font-semibold disabled:opacity-40"
      >
        {saving ? "Saving..." : saved ? "✓ Saved" : "Save Selection"}
      </button>
    </div>
  );
};

export default ReunionLevel5Picker;
